import { PaginatedTitle } from "../service/cash-title.service";
import { CashTitle } from "./cash-title";

export enum CASH_TITLE_MOVEMENT_TYPE {
  CREATED_ACTIVE,
  CREATED_ACTIVE_BY_OS,
  CREATED_ACTIVE_BY_ORDER,
  CREATED_ACTIVE_BY_SINGLE_PART_INVOICE_ISSUING,
  CREATED_ACTIVE_BY_SINGLE_LABOR_INVOICE_ISSUING,
  ACTIVATED_BY_OS_ISSUING,
  ACTIVATED_BY_ORDER_ISSUING,
  ACTIVATED_BY_SINGLE_PART_INVOICE_ISSUING,
  DELETED_BY_INVOICE_CANCELLATION,
  MANUALLY_DELETED,
  DELETED_BY_OS_TITLES_RECRIATION_PROCESS,
  ACTIVATED_BY_SINGLE_LABOR_INVOICE_ISSUING,
  ACTIVATED_BY_TRY_AGAIN_ORDER_ISSUING,
  ACTIVATED_BY_TRY_AGAIN_OS_ISSUING,
  ACTIVATED_BY_TRY_AGAIN_SINGLE_INVOICE_ISSUING,
  ADVANCE_ACTIVATED_BY_INVOICE_CANCELLATION,
  TITLE_UPDATED,
  INACTIVED,
  INACTIVED_ADVANCE_BY_OS_INVOICE_APPROVED,
  CREATED_INACTIVE,
  CANCELED,
  CANCELED_BY_ORDER_CANCELLATION,
  CANCELED_BY_INVOICE_CANCELLATION,
  LOW_CREATED,
  LOW_CREATED_BY_ADVANCE,
  LOW_CREATED_BY_RENEGOTIATION,
  ADVANCE_USED,
  LOW_CANCELLED,
  LOW_MANUALLY_UPDATED_IN_PERIOD_COMPONENT,
  LOW_UPDATED_IN_PERIOD_COMPONENT_BY_FIX_BALANCE_FUNCTIONS,
  LOW_UPDATED_BY_RETROACTIVE_EVENT_CREATION,
  LOW_UPDATED_BY_RETROACTIVE_EVENT_DELETION,
  INACTIVED_BY_RENEGOCIATION,
  LOW_CREATED_BY_MULTIPLE_LOWS,
  MANUALLY_CANCELED = 34,
  CREATED_ACTIVE_BY_XML_IMPORT,
  LOW_WITH_ADVANCE_CANCELLED
} 

export enum CASH_TITLE_CREATED_BY {
  OS_FINANCE = 1,
  ORDER_FINANCE,
  LABOR_INVOICE_FINANCE,
  TRY_AGAIN_LABOR_INVOICE_FINANCE,
  PART_INVOICE_FINANCE,
  TRY_AGAIN_PART_INVOICE_FINANCE,
  LOOSE_TITLE,
  LOOSE_TITLE_AGAINST_CARD_ADMIN,
  LOOSE_TITLE_AGAINST_CARD_ADMIN_FROM_LOW,
  LOOSE_TITLE_ADVANCE,
  LOOSE_TITLE_ADVANCE_FROM_OS,
  LOOSE_TITLE_BY_PROVISION,
  XML_IMPORT_AUTO_GENERATED,
  XML_IMPORT_MANUALLY_GENERATED,
  PART_INVOICE_FINANCE_TRANSPORTER,
  DELETING_TITLE,

  /** When the created by is set to UPDATING_TITLE means that is a update operation, so we just discard the field and set this value */
  UPDATING_TITLE,
  LOOSE_TITLE_FROM_RENEGOCIATION,
  ERROR_AT_TITLE_GENERATION,
  UPDATING_TITLE_BY_LOW_WITH_ADVANCE_CANCELED
}

export interface CreateCashTitleMovimentationParamethers {

  title: CashTitle | PaginatedTitle;
  origin: CASH_TITLE_CREATED_BY;
  creationCompany: string;
  targetCompany: string;
  movementType: CASH_TITLE_MOVEMENT_TYPE;
  userId: string;

  isSupplier?: boolean;
  renegociationTitlesId?: string[];
  valueChanged?: number;
  invoiceId?: string;
  invoiceNumber?: number | string;
  osId?: string;
  orderId?: string;
  titleErro?: string;

  triggerFromAdmCardCreation?: string;  

  /** Used when the title is updated, to handle and save what was changed, we send this paramether to check the changes */
  titleBeforeChanges?: Partial<CashTitle>;

  advanceTargetId?: string;
  advancesUsed: string[];
}